import { useEffect } from "react";
import { track, type JourneyProps } from "~/lib/journey-tracker.client";

/**
 * Records an overlay (a modal, a sheet, a photo viewer) opening when the
 * component mounts and closing when it unmounts. Modal contents mount on open
 * and unmount on close, so one call inside the content covers every place
 * that opens it. Props are read once, at opening.
 */
export function useTrackOverlay(overlay: string, props?: JourneyProps) {
  useEffect(() => {
    track("overlay_open", { overlay, ...props });
    return () => track("overlay_close", { overlay, ...props });
    // Once per mount, by design: the props are the ones at opening.
  }, []);
}
